/**
 * During app deployment a special json file is generated to provide custom variables,
 * that are being set based on the system environment (i.e. Development or Production server).
 *
 * Since this file is a hard requirement needed for the main app to bootstrap,
 * retrieve the data before starting the app.
 *
 */
define('web-urls',['require','exports','module','jquery','lodash'],function (require, exports) {
    var $ = require('jquery');
    var _ = require('lodash');

    var config = {};

    exports.retrieveConfig = function (canOverride) {
        var retrievingConfig = $.Deferred();

        $.ajax({
            dataType: 'json',
            url: '/public/properties/weburls.json',
            headers: {'Cache-Control': 'no-cache'}
        })
            .then(function (webUrls) {
                config = webUrls;

                if (canOverride) {
                    $.getJSON(config.urls.globalConfigUrl)
                        .then(function (overrides) {
                            // All the config options are namespaced under "urls" for legacy reasons
                            config = _.merge(config, {urls: overrides});
                        })
                        .always(function () {
                            // The app can still function without the overrides.
                            // Continue without the overrides if the request fails, or if the response is malformed.
                            retrievingConfig.resolve();
                        });
                } else {
                    retrievingConfig.resolve();
                }
            })
            .fail(function (data) {
                // The app cannot function without the base config, throw an error
                throw new Error(data.responseText);
            });

        return retrievingConfig.promise();
    };

    exports.get = function (key, category) {
        var _category = category || 'urls';
        return config[_category][key];
    };

    exports.getConfigUrls = function () {
        return config;
    };
});

